export default __webpack_public_path__ + "static/media/Praeceptum Bands.a3a6f267.jpg";